<script setup lang="ts">
import { computed } from 'vue';
import AuthLayout from '../components/AuthLayout.vue';

const copy = computed(() => ({
  title: window.__UNSUBSCRIBE_RESULT__?.title ?? '',
  body: window.__UNSUBSCRIBE_RESULT__?.body ?? '',
  cta: window.__UNSUBSCRIBE_RESULT__?.cta ?? '',
  href: window.__UNSUBSCRIBE_RESULT__?.href ?? '/',
}));

const topLinks = computed(() =>
  copy.value.cta ? [{ url: copy.value.href, text: copy.value.cta }] : []
);
const bottomLinks = computed(() => []);
</script>

<template>
  <AuthLayout :title="copy.title" :top-links="topLinks" :bottom-links="bottomLinks">
    <p class="text-white text-base leading-relaxed">{{ copy.body }}</p>
  </AuthLayout>
</template>
